import { Col, Row } from 'antd';
import Styles from './HighlightedProductSection.module.scss';
import VerticalSection from '../../Molecules/VerticalSection';
import { THighlightedProductSection } from './definitions';
import { useFetchProductData } from 'Pages/Home/Hooks/useFetchProductData';
import Image from '../../Atoms/Image';
import { TProductData } from 'Pages/Home/Hooks/definitions';
import { getCategoryName } from 'Pages/Home/Helper/Formatter';

function HighlightedProductSection({}: THighlightedProductSection) {
  const { data: hotProductData } = useFetchProductData(
    'editors-choices',
    'all_category',
    40,
    300,
  );

  const { data: mostPopularData } = useFetchProductData(
    'most-popular',
    '',
    40,
    300,
  );

  const { data: topSellingData } = useFetchProductData(
    'top-selling',
    'all_category',
    40,
    300,
  );

  const { data: priceDropData } = useFetchProductData(
    'price-drop',
    'all_category',
    40,
    300,
  );

  const onClickProduct = (product: TProductData) => {
    window.open(
      `/${getCategoryName(product.category)}/${product.brand}/${product.slug}?from=home`,
      '_blank',
    );
  };

  const onHotProductViewAll = () => {
    window.open('/hot-products', '_blank');
  };

  const onMostPopularViewAll = () => {
    window.open('/browse-all?sort_by=most_popular', '_blank');
  };

  const onBestSellingViewAll = () => {
    window.open('/best-selling', '_blank');
  };

  const onPriceDropViewAll = () => {
    window.open('/price-drop', '_blank');
  };

  return (
    <div className={Styles['highlighted-product-section-wrapper']}>
      <Row
        className={Styles['highlighted-product-section']}
        align="middle"
        justify="space-between"
        gutter={[24, 0]}
      >
        <Col span={6}>
          <VerticalSection
            title="HOT PRODUCTS"
            actionText="View All"
            onAction={onHotProductViewAll}
          >
            {hotProductData.map((product, index) => (
              <Row
                key={`hot-product-${index}`}
                className={Styles['product-row']}
                align="middle"
                justify="center"
                onClick={() => onClickProduct(product)}
              >
                <Image
                  src={product.image}
                  className={Styles['product-image']}
                  type={product.category}
                />
              </Row>
            ))}
          </VerticalSection>
        </Col>
        <Col span={6}>
          <VerticalSection
            title="MOST POPULAR"
            actionText="View All"
            onAction={onMostPopularViewAll}
          >
            {mostPopularData.map((product, index) => (
              <Row
                key={`most-popular-product-${index}`}
                className={Styles['product-row']}
                align="middle"
                justify="center"
                onClick={() => onClickProduct(product)}
              >
                <Image
                  src={product.image}
                  className={Styles['product-image']}
                  type={product.category}
                />
              </Row>
            ))}
          </VerticalSection>
        </Col>
        <Col span={6}>
          <VerticalSection
            title="BEST SELLING"
            actionText="View All"
            onAction={onBestSellingViewAll}
          >
            {topSellingData.map((product, index) => (
              <Row
                key={`best-selling-product-${index}`}
                className={Styles['product-row']}
                align="middle"
                justify="center"
                onClick={() => onClickProduct(product)}
              >
                <Image
                  src={product.image}
                  className={Styles['product-image']}
                  type={product.category}
                />
              </Row>
            ))}
          </VerticalSection>
        </Col>
        <Col span={6}>
          <VerticalSection
            title="PRICE DROP"
            actionText="View All"
            onAction={onPriceDropViewAll}
          >
            {priceDropData.map((product, index) => (
              <Row
                key={`price-drop-product-${index}`}
                className={Styles['product-row']}
                align="middle"
                justify="center"
                onClick={() => onClickProduct(product)}
              >
                <Image
                  src={product.image}
                  className={Styles['product-image']}
                  type={product.category}
                />
              </Row>
            ))}
          </VerticalSection>
        </Col>
      </Row>
    </div>
  );
}

export default HighlightedProductSection;
